"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleMatcher = void 0;
var __1 = require("../..");
var ArticleMatcher = /** @class */ (function () {
    function ArticleMatcher() {
    }
    ArticleMatcher.isCompetingWithSeller = function (seller, _a, cardmarketUsername) {
        var reputation = _a.reputation, level = _a.level, countries = _a.countries, sellCount = _a.sellCount, excludedUsers = _a.excludedUsers;
        if (__spreadArray([cardmarketUsername], (excludedUsers || []), true).includes(seller.username))
            return false;
        if (seller.reputation > Number(reputation))
            return false;
        if (seller.isCommercial < Number(level))
            return false;
        if (seller.sellCount < Number(sellCount))
            return false;
        if (Array.isArray(countries) && countries.length && !countries.includes(seller.country)) {
            return false;
        }
        if (typeof countries === 'string' && countries !== seller.country) {
            return false;
        }
        return true;
    };
    ArticleMatcher.isBetterOrEqual = function (article, parameters, pricingStrategy, playsetCount) {
        if (playsetCount === void 0) { playsetCount = 4; }
        var condition = parameters.condition, isShiny = parameters.isShiny, isPlayset = parameters.isPlayset, idLanguage = parameters.idLanguage, quantity = parameters.quantity, isFirstEd = parameters.isFirstEd, isSigned = parameters.isSigned, isAltered = parameters.isAltered;
        //condition
        var CONDITIONS_MAP = {
            MT: 1,
            NM: 2,
            EX: 3,
            GD: 4,
            LP: 5,
            PL: 6,
            PO: 7,
        };
        if (CONDITIONS_MAP[article.condition] >
            Math.max(CONDITIONS_MAP[condition], pricingStrategy.NMeqEX ? 3 : 2))
            return false;
        //language
        var allowedLanguages = pricingStrategy.strictLanguage
            ? [idLanguage]
            : [__1.CardLanguage.English, idLanguage];
        if (!allowedLanguages.includes(Number(article.idLanguage))) {
            return false;
        }
        //isFoil
        if (isShiny !== Boolean(article.isShiny))
            return false;
        //isFirstEd
        if (pricingStrategy.strictFirstEd && isFirstEd !== Boolean(article.isFirstEd))
            return false;
        //isSigned
        if (isSigned !== Boolean(article.isSigned))
            return false;
        //isAltered
        if (isAltered !== Boolean(article.isAltered))
            return false;
        //quantity
        if (!pricingStrategy.disablePlaysetPricing &&
            (isPlayset || Number(quantity) >= playsetCount) &&
            !(article.isPlayset || article.quantity >= playsetCount))
            return false;
        return true;
    };
    ArticleMatcher.getMatchingArticles = function (_a) {
        var article = _a.article, articleData = _a.articleData, competitor = _a.competitor, strategy = _a.strategy, playsetCount = _a.playsetCount, cardmarketUsername = _a.cardmarketUsername, limit = _a.limit;
        var matchingArticles = [];
        for (var _i = 0, _b = articleData.data; _i < _b.length; _i++) {
            var cardmarketArticle = _b[_i];
            if (ArticleMatcher.isCompetingWithSeller(cardmarketArticle.seller, competitor, cardmarketUsername || '') &&
                ArticleMatcher.isBetterOrEqual(cardmarketArticle, article, strategy, playsetCount)) {
                matchingArticles.push(cardmarketArticle);
                if (limit && matchingArticles.length >= limit)
                    break;
            }
        }
        return matchingArticles;
    };
    return ArticleMatcher;
}());
exports.ArticleMatcher = ArticleMatcher;
//# sourceMappingURL=matcher.js.map